import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';
@Injectable()
export class SimuladorLiquidoService extends BaseService {
  getSimuladorLiquido(filter?: any) {
    const url = `${environment.portalApi}/SimuladorLiquido/GetSimuladorLiquido?` + this.paramsToQueryString(filter);
    return this.http.get(url, { headers: this.createHeader() });
  }
  getSimuladorPlanoIV(filter?: any) {
    const url = `${environment.portalApi}/SimuladorLiquido/GetSimuladorIV?` + this.paramsToQueryString(filter);
    return this.http.get(url, { headers: this.createHeader() });
  }
  getSimuladorPlanoIVCSV(filter?: any) {
    const url = `${environment.portalApi}/SimuladorLiquido/GetSimuladorIVCsv?` + this.paramsToQueryString(filter);
    return this.http.get(url, { headers: this.createHeader(), responseType: 'blob' });
  }
}